<div class='explorer-nav-row' [class.active]="active" [style.paddingLeft.px]="(depth + 1) * 12">
  @if (hasChildFolder && !expanded && !folder.fetching) {
    <i class="icon fas fa-plus" (click)="folder.contentsFetched ? toggleExpansion() : setActiveDirectory()"></i>
  }
  @if (hasChildFolder && expanded && !folder.fetching) {
    <i class="icon fas fa-minus" (click)="toggleExpansion()"></i>
  }
  @if (hasChildFolder && folder.fetching) {
    <i class="icon fas fa-spinner spinning"></i>
  }
  <div title="{{ folder.details.name }}" [ngClass]="folder.details.type | lowercase"
    [class.push-right]="!hasChildFolder" class="explorer-nav-row-info" (click)="setActiveDirectory()">
    <span>{{ folder.details.name || '{inv-unknown}' }}</span>
    @if (folder.details.type === 'BACKUP') {
      <span>({{ folder.details.backupDate * 1000 | date:'short' }})</span>
    }
  </div>
</div>
@if (folder.contents !== null && folder.contents.length > 0 && expanded) {
  @for (child of folder.contents; track child; let index = $index) {
    @if (child.details.type !== 'FILE') {
      <app-explorer-nav-row [folder]="folder.contents[index]" [depth]="depth + 1"></app-explorer-nav-row>
    }
  }
}